import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Team plans", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("More information about about Cadrelo plans and pricing can be found "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://cadrelo.com/pricing",
    target: "_blank"
  }, "here"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = {
  key: 1,
  class: "error"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" The latest invoice for the team has not been paid. Please use the ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Customer Portal", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" to update your payment details ")
const _hoisted_8 = {
  key: 2,
  class: "error"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "renewed", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" before then ")
const _hoisted_11 = {
  key: 3,
  class: "subscriptions grid"
}
const _hoisted_12 = { class: "subscriptions__plan col-12 col-lg-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "h4 no-margin" }, "Free", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "p-small" }, " Empower teams of up to 5 people ", -1)
const _hoisted_15 = {
  key: 0,
  class: "h6 activeplan"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Downgrade ")
const _hoisted_17 = {
  key: 2,
  class: "error"
}
const _hoisted_18 = { class: "subscriptions__plan col-12 col-lg-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "h4 no-margin" }, "Team", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "p-small" }, [
  /*#__PURE__*/_createTextVNode(" Unlock our full feature set for teams of any size."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "$5 per month per user"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "h6 activeplan"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Upgrade ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppPanel = _resolveComponent("AppPanel")!

  return (_openBlock(), _createBlock(_component_AppPanel, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      (_ctx.activeTeam?.subscription?.plan === _ctx.Plan.FREE && _ctx.activeMembers > 5)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " As the team has more than 5 members you must upgrade to the Team Plan to continue using Cadrelo "))
        : _createCommentVNode("", true),
      (_ctx.activeTeam?.subscription?.plan === _ctx.Plan.TEAM && !_ctx.activeTeam.subscription.paid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, { to: "/settings#billing" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTeam?.subscription?.plan === _ctx.Plan.TEAM && _ctx.activeTeam.subscription.cancelAt)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _createTextVNode(" Your subscription will be downgraded to the Free Plan on " + _toDisplayString(_ctx.activeTeam.subscription.cancelAt) + " unless ", 1),
            _createVNode(_component_router_link, { to: "/settings#billing" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTeam?.subscription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              (_ctx.activeTeam.subscription.plan === _ctx.Plan.FREE)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, " This plan is active "))
                : (_ctx.canSwitchToFree && !_ctx.activeTeam.subscription.cancelAt)
                  ? (_openBlock(), _createBlock(_component_AppButton, {
                      key: 1,
                      theme: 'secondary',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activateFreePlan())),
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (!_ctx.canSwitchToFree)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, " You cannot switch to the free plan as the team has more than 5 active members or pending invites "))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              (_ctx.activeTeam.subscription.plan === _ctx.Plan.TEAM)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, " This plan is active "))
                : (_openBlock(), _createBlock(_component_AppButton, {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activateTeamPlan())),
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }, 8, ["loading"]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}